import { getRequest, postRequest } from '../request/request.service';
import {
  CheckoutSessionPayload,
  CheckoutSessionResponse,
  PlansResponse,
  ValidateBypassCodeResponse,
} from './billing.service.types';

export async function getPlans() {
  return getRequest<PlansResponse>('/subscriptions/plans');
}

export async function createCheckoutSession(data: CheckoutSessionPayload) {
  return postRequest<CheckoutSessionResponse>('/checkout_sessions', { data });
}

export async function syncSubscription() {
  return postRequest<{ synced: boolean }>('/subscriptions/sync');
}

export async function validateBypassCode(code: string) {
  return postRequest<ValidateBypassCodeResponse>('/bypass_codes/validate', {
    data: { code },
  });
}
